import { Link, useParams } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { calculateLeftTime } from "../../../../../../utils/time";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { deleteFileFromCase } from "../../../../../../redux/action/cases/casesAction";
import ConfirmModal from "../../../../../UI/ConfirmModal";
import { useState } from "react";
import PublicStatusForClient from "../../../../../Events/DateItems/Item/PublicStatus";

const CaseContentFilesItem = ({ info, dontShowAction = false, ...props }) => {
  const dispatch = useDispatch();

  const [showDeleteFileAlert, setShowDeleteFileAlert] = useState(false);

  const [showTooltipClient, setShowTooltipClient] = useState(false);
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const params = useParams();

  const [cookies] = useCookies(["authToken"]);

  const showConfirmModalMessage = () => {
    setShowDeleteFileAlert(true);
  };

  const deleteFile = async () => {
    await dispatch(
      await deleteFileFromCase(params.id, info.id, cookies.authToken),
    );
  };

  const openTooltipClient = () => {
    if (!showTooltipClient) {
      setShowTooltipClient(true);

      setTimeout(() => {
        setShowTooltipClient(false);
      }, 1500);
    }
  };

  const fileType = () => {
    if (info.kind === "image") return "تصویر سند یا مدرک";
    else return "ابلاغیه";
  };

  const putTime = () => {
    return calculateLeftTime(info.created_at);
  };

  const putSize = () => {
    const size = (info.size / 100000) * 100;

    if (size < 500) {
      return size.toFixed(0) + " کیلوبایت ";
    } else return (size / 1000).toFixed(2) + " مگابایت ";
  };

  return (
    <li className="bg-white shadow-sm border border-gray-100 rounded-2xl p-4 flex flex-col gap-3 transition-all hover:shadow-md">
      <div className="flex items-center gap-3">
        {info.kind === "image" ? (
          <img
            className="w-12 h-12 rounded-xl object-cover border border-gray-100 outline outline-2 outline-primary/20"
            src={info.url}
            alt=""
          />
        ) : (
          <div className="w-12 h-12 flex items-center justify-center bg-primary/5 rounded-xl text-primary">
            <ReactSVG
              className="w-6"
              src={`${process.env.PUBLIC_URL}/assets/images/icons/file.svg`}
            />
          </div>
        )}

        <div className="flex-1 min-w-0">
          <h3 className="text-gray-900 font-semibold text-sm truncate">
            {info.caption || "بدون عنوان"}
          </h3>
          <span className="text-xs text-gray-500">
            {!info.context ? fileType() : info.context} • {putSize()}
          </span>
        </div>

        {info.is_public && (
          <PublicStatusForClient
            showTooltipClient={showTooltipClient}
            onClick={openTooltipClient}
            color={"text-primary"}
          />
        )}
      </div>

      {info.description && (
        <div
          onClick={() => setIsDescriptionOpen(!isDescriptionOpen)}
          className="bg-gray-50 rounded-xl p-3 cursor-pointer"
        >
          <button className="text-xs font-medium text-primary flex items-center gap-1">
            {isDescriptionOpen ? "بستن توضیحات" : "مشاهده توضیحات"}
          </button>

          <div
            className={`transition-all duration-300 ease-in-out overflow-hidden ${isDescriptionOpen ? "max-h-32 mt-2" : "max-h-0"}`}
          >
            <p className="text-xs text-gray-600 leading-6 text-justify">
              {info.description}
            </p>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between pt-2 border-t border-gray-200">
        <span className="text-xs text-gray-500 flex items-center gap-1">
          <span className="w-1.5 h-1.5 rounded-full bg-gray-400"></span>
          {putTime()}
        </span>

        <div className="flex items-center gap-2">
          <button
            onClick={showConfirmModalMessage}
            className="p-2 text-red-500 bg-red-50 rounded-lg transition-colors"
          >
            <ReactSVG
              className="w-4 h-4"
              src={`${process.env.PUBLIC_URL}/assets/images/icons/delete-2.svg`}
            />
          </button>
          <Link
            to={info.url}
            target="_blank"
            download={true}
            className="p-2 text-green-600 bg-green-50 rounded-lg transition-colors"
          >
            <ReactSVG
              className="w-4 h-4"
              src={`${process.env.PUBLIC_URL}/assets/images/icons/download.svg`}
            />
          </Link>
        </div>
      </div>

      {showDeleteFileAlert && (
        <ConfirmModal
          title="حذف فایل"
          description="آیا میخواهید این فایل را حذف کنید؟"
          show={showDeleteFileAlert}
          setShow={setShowDeleteFileAlert}
          onConfirm={deleteFile}
          className={""}
          backdropClass={""}
        >
          <div className="w-14 h-14 bg-white shadow-custom-lg flex items-center justify-center rounded-2xl text-rose-500">
            <ReactSVG
              src={`${process.env.PUBLIC_URL}/assets/images/icons/delete.svg`}
              className="w-10 h-10"
            />
          </div>
        </ConfirmModal>
      )}
    </li>
  );
};

export default CaseContentFilesItem;